<template>
  <div class="user-profile_upe">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>

    <div class="page-form">

      <div class="page-container_pcr">
        <router-link
          class="help-link"
          style="text-align: center;"
          :to="{ path: '/help/22'}"
          target="_blank">
          Подробнее о моем профиле в разделе Помощь
        </router-link>

        <div class="block-wrap block-wrap_btns" style="padding-top: 0;">
          <button v-show="profileMode === 'edit'"
            @click="setProfileMode('view')"
            class="trans-btn trans-btn_white" style="margin: 0 10px;">
            Посмотреть профиль</button>
          <button v-show="profileMode === 'view'"
            @click="setProfileMode('edit')"
            class="trans-btn trans-btn_white" style="margin: 0 10px;">
            Редактировать профиль</button>
        </div>

        <user-profile-display
          v-if="profileMode === 'view'"
          class="upd--grad-bg"
          :userId="$store.getters['user/getUserId']"/>

        <app-inputs
          ref="inputs"
          v-if="profileMode === 'edit'">

          <div class="block-wrap block-wrap_error" v-if="error.length">
            <div
              v-for="(e, i) in error"
              :key="`error-${i}`"
              class="block-wrap-error">
              {{ e }}
            </div>
          </div>

          <div class="block-wrap upe_visibility-block_uvb">
            <div class="bw_block-title">Настроить публичную видимость полей профиля</div>
            <app-input
              ref="visibilityMail"
              style="padding-top: 0"
              widget="AppSelect"
              :options="{ name: 'visibilityMail', title: 'Показывать ваш e-mail в профиле',
                options: userFieldsVisibility, clearable: false
              }"/>
            <app-input
              ref="visibilityPhone"
              widget="AppSelect"
              :options="{ name: 'visibilityPhone', title: 'Показывать ваш номер телефона в профиле',
                options: userFieldsVisibility, clearable: false
              }"/>
          </div>

          <div class="block-wrap" v-if="timezonesVoc">
            <app-input
              ref="timezone"
              widget="AppSelect"
              :options="{ name: 'timezone', title: 'Часовой пояс', options: timezonesVoc,
                filterable: true, placeholder: 'Начинайте ввод...' }"/>
          </div>

          <div class="block-wrap">
            <app-input
              ref="avatar"
              widget="AppAvatar"
              :options="{ name: 'avatar', title: 'Изображение для аватара' }"/>
          </div>

          <div class="block-wrap">
            <app-input
              ref="mail"
              widget="AppMailComplex"
              :options="{ name: 'mail', title: 'E-mail', required: true,
                unique: true, verify: true }"/>
            <div class="input-notice text-center">
              Данный e-mail будет использоваться для входа на сайт.</div>
          </div>

          <!--<div class="block-wrap">
            <app-input
              ref="phone"
              widget="AppPhone"
              :options="{ name: 'phone', title: 'Номер телефона' }"/>
          </div>-->

          <div class="block-wrap">
            <app-input
              ref="phone"
              widget="AppText"
              :options="{ name: 'phone', title: 'Номер телефона' }"/>
          </div>

          <div class="block-wrap">
            <app-input
              ref="fio"
              widget="AppFio"
              :options="{ name: 'fio', title: 'Ф.И.О.', required: true }"/>
          </div>

          <div class="block-wrap">
            <app-input
              ref="academicDegree"
              widget="AppSelect"
              :options="{ name: 'academicDegree', title: 'Ученые степени',
                multiple: true, options: academicDegrees }"/>
          </div>

          <div class="block-wrap">
            <app-input
              ref="academicTitle"
              widget="AppSelect"
              :options="{ name: 'academicTitle', title: 'Учёное звание',
                options: academicTitles }"/>
          </div>

          <div class="block-wrap">
            <app-input
              widget="AppPassword"
              ref="password"
              :options="{ name: 'password', title: 'Пароль',
                confirm: true, strength: true }"/>
            <div class="input-notice text-center">
              Оставьте оба поля пустыми, если не хотите менять пароль.</div>
          </div>

          <div class="block-wrap">
            <app-input
              ref="jobs"
              widget="AppJob"
              :options="{ name: 'job', title: 'Место работы', required: true, multiple: true }"/>
          </div>

          <div class="block-wrap">
            <div class="buttons-wrap">
              <button class="vivid-button" @click="submit">Сохранить</button>
            </div>
          </div>

        </app-inputs>

      </div>

    </div>

    <page-footer/>

  </div>
</template>

<script>
/* eslint-disable default-case */
import Vue from 'vue';
import axios from 'axios';
import UserProfileDisplay from '@/components/UserProfileDisplay';
import Misc from '../../mixins/Misc';
import academicDegrees from '../../data/academic-degrees';
import academicTitles from '../../data/academic-titles';
import userFieldsVisibility from '../../data/user-fields-visibility';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import AppInput from '../inputs/AppInput';
import AppInputs from '../inputs/AppInputs';

export default {

  mixins: [Misc],

  components: { AppInput, AppInputs, PageHeader, NavInner, PageFooter, UserProfileDisplay },

  data() {
    return {
      error: [],
      message: '',
      academicDegrees,
      academicTitles,
      userFieldsVisibility,
      timezonesVoc: [],
      profileMode: 'view', // 'view' || 'edit',
    };
  },

  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', '/static/js/jsrsasign-all-min.js');
    document.head.appendChild(script);
  },

  methods: {

    setProfileMode(mode) {
      this.profileMode = mode;
      if (mode === 'edit') {
        this.fetchData();
      }
    },

    fetchData() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId) {
        axios.get('vocabularies/timezones').then((r) => {
          this.timezonesVoc = r.data;
        });

        axios.get(`users/${userId}`).then((response) => {
          const d = response.data;
          this.$refs.mail.setValue([d.Mail]);
          this.$refs.phone.setValue([d.Phone]);
          this.$refs.fio.setValue({
            surname: d.Surname,
            name: d.Name,
            patronymic: d.Patronymic,
          });
          if (
            (Array.isArray(d.AcademicDegree) && !d.AcademicDegree.length)
            || d.AcademicDegree === null
          ) {
            d.AcademicDegree = [''];
          }
          this.$refs.academicDegree.setValue(d.AcademicDegree);
          this.$refs.academicTitle.setValue([d.AcademicTitle]);
          this.$refs.jobs.setValue(d.Jobs);
          this.$refs.timezone.setValue([d.TimeZone]);
          if (d.Visibility) {
            if (typeof d.Visibility.Mail !== 'undefined') {
              this.$refs.visibilityMail.setValue([d.Visibility.Mail.toString()]);
            }
            if (typeof d.Visibility.Phone !== 'undefined') {
              this.$refs.visibilityPhone.setValue([d.Visibility.Phone.toString()]);
            }
          } else {
            this.$refs.visibilityMail.setValue(['0']);
            this.$refs.visibilityPhone.setValue(['0']);
          }
        });
      }
    },

    submit() {
      Vue.$loading.on();
      this.scrollTop(() => {
        if (!this.$refs.inputs.hasErrors()) {
          const values = this.$refs.inputs.getValues();
          values.visibility = {
            mail: values.visibilityMail,
            phone: values.visibilityPhone,
          };
          delete values.visibilityMail;
          delete values.visibilityPhone;
          delete values.avatar;
          if (values.password && values.password.password) {
            const keysPair = window.GenerateKeysPair(values.password.password);
            values.privateKey = keysPair[0];
            values.publicKey = keysPair[1];
          }
          this.$message.closeAll();
          this.$message('Изменения сохраняются...');
          axios.put('users', JSON.stringify(values))
            .then((r) => {
              Vue.$loading.off();
              this.$store.commit('user/setUserData', r.data);
              this.$refs.mail.setValue([values.mail.mail]);
              this.$message.closeAll();
              this.$message.success('Изменения сохранены.');
              this.$refs.password.clearValue();
            })
            .catch((error) => {
              Vue.$loading.off();
              const respError = error.response.data;
              this.$message.closeAll();
              this.$message({
                type: 'error',
                message: respError,
                duration: 7000,
              });
            });
        } else {
          Vue.$loading.off();
          this.$message.closeAll();
          this.$message.success('Исправьте ошибки в указанных полях.');
        }
      });
    },

  },

};
</script>

<style lang="scss">
.block-wrap {
  max-width: 700px;
}
.user-profile_upe {
  .upe_visibility-block_uvb {
    .input-title {
      text-align: left;
      font-weight: 300;
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserProfile.vue